import { CARD_FORMATS } from 'consts';
import { isCardNumberValid, isValidFutureYear, isValidMonth } from 'utilities';

export const COMMUNICATION_MESSAGES = {
  GET_HOSTED_PARAMS: 'GET_HOSTED_PARAMS',
  ON_LOAD: 'ON_LOAD',
  FORM_VALID: 'FORM_VALID',
  FORM_INVALID: 'FORM_INVALID',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS'
};

export const FIELDS = {
  CARD_NUMBER: 'card_number',
  NAME: 'name',
  CVV: 'cvv',
  EXPIRATION_MONTH: 'expiration_month',
  EXPIRATION_YEAR: 'expiration_year',
  UPLOAD_FILE: 'upload_file'
};

export const HOSTED_CARD_REGEXES = {
  [FIELDS.CARD_NUMBER]: /^[0-9]{16}$/,
  [FIELDS.NAME]: null,
  [FIELDS.CVV]: /^[0-9]{3,4}$/,
  [FIELDS.EXPIRATION_MONTH]: /^0[1-9]|1[012]$/,
  [FIELDS.EXPIRATION_YEAR]: /^[\d]{2}$/
};
export const HOSTED_CARD_ERRORS = {
  [FIELDS.CARD_NUMBER]: 'Invalid card number',
  [FIELDS.NAME]: '',
  [FIELDS.CVV]: 'CVV must be between 3 and 4 digits long.',
  [FIELDS.EXPIRATION_MONTH]: 'Please enter a valid month.',
  [FIELDS.EXPIRATION_YEAR]: 'Please enter a valid year.'
};
export const HOSTED_CARD_VALIDATIONS = {
  [FIELDS.CARD_NUMBER]: (_, value) => isCardNumberValid(value),
  [FIELDS.EXPIRATION_MONTH]: (_, value) => isValidMonth(value),
  [FIELDS.EXPIRATION_YEAR]: (_, value, formValues) =>
    isValidFutureYear(value, formValues[FIELDS.EXPIRATION_MONTH]),
  DEFAULT: (name, value) =>
    HOSTED_CARD_REGEXES[name] ? HOSTED_CARD_REGEXES[name].test(value) : true
};
export const HOSTED_CARD_FORMATS = {
  [FIELDS.CARD_NUMBER]: CARD_FORMATS[FIELDS.CARD_NUMBER],
  [FIELDS.EXPIRATION_MONTH]: CARD_FORMATS[FIELDS.EXPIRATION_MONTH],
  [FIELDS.EXPIRATION_YEAR]: CARD_FORMATS[FIELDS.EXPIRATION_YEAR],
  [FIELDS.CVV]: CARD_FORMATS[FIELDS.CVV]
};

export const EXCLUDED_FIELDS_TO_CUSTOM_VALIDATE = [FIELDS.CARD_NUMBER];

export const INITIAL_STATE = {
  touched: {
    [FIELDS.CARD_NUMBER]: false,
    [FIELDS.NAME]: false,
    [FIELDS.CVV]: false,
    [FIELDS.EXPIRATION_MONTH]: false,
    [FIELDS.EXPIRATION_YEAR]: false
  },
  errors: {
    [FIELDS.CARD_NUMBER]: 'Required',
    [FIELDS.NAME]: 'Required',
    [FIELDS.CVV]: 'Required',
    [FIELDS.EXPIRATION_MONTH]: 'Required',
    [FIELDS.EXPIRATION_YEAR]: 'Required'
  },
  values: {
    [FIELDS.CARD_NUMBER]: '',
    [FIELDS.NAME]: '',
    [FIELDS.CVV]: '',
    [FIELDS.EXPIRATION_MONTH]: '',
    [FIELDS.EXPIRATION_YEAR]: ''
  }
};

export const INPUTS = [
  {
    type: 'text',
    name: FIELDS.NAME,
    label: 'Card Holder Name',
    format: ''
  },
  {
    type: 'number',
    name: FIELDS.CARD_NUMBER,
    label: 'Card Number',
    format: HOSTED_CARD_FORMATS[FIELDS.CARD_NUMBER]
  },
  {
    name: 'expiration',
    styleProp: 'expiration',
    inputs: [
      {
        type: 'number',
        name: FIELDS.EXPIRATION_MONTH,
        label: 'Expiration Month',
        format: HOSTED_CARD_FORMATS[FIELDS.EXPIRATION_MONTH]
      },
      {
        type: 'number',
        name: FIELDS.EXPIRATION_YEAR,
        label: 'Expiration Year',
        format: HOSTED_CARD_FORMATS[FIELDS.EXPIRATION_YEAR]
      }
    ]
  },
  {
    type: 'number',
    name: FIELDS.CVV,
    label: 'CVV',
    format: HOSTED_CARD_FORMATS[FIELDS.CVV]
  }
];

export const DEFAULT_EMPTY_MESSAGE = 'This field is required';

export const HOSTED_PAYOUT_CARD_TOKENIZATION_FORM_NAME =
  'hostedPayoutCardTokenizationForm';
